import { log } from 'log';
import * as pas from 'js/hooks/auth/pas';
import { htcmdService } from 'js/services/htcmd.service';

export {
    storeRememberMeItem,
    retrieveRememberMeItem,
    removeRememberMeItem,
    getIovationBlackbox,
    parsePasLoginResponse
} from 'js/hooks/auth/helpers';

export const externalLoginAction = async ({ userId, userName, sessionToken, afterRegisterLogin, isLoginActionPrevented }) => {
    if (!sessionToken) {
        return;
    }

    if (htcmdService.isEnabled) {
        log('warn', 'NATIVE APP MODE. PREVENT LOGIN TO OPEN API');

        if (afterRegisterLogin) {
            if (!isLoginActionPrevented) {
                const tempTokenResponse = await pas.getTempToken();
                const token = tempTokenResponse?.data?.sessionToken?.sessionToken;

                htcmdService.registerNative({ userId, username: userName, sessionToken: token });
            }
        } else {
            htcmdService.login({ userId, username: userName, sessionToken });

            return Promise.reject({ data: { isPrevented: true } });
        }
    } else if (htcmdService.isWrapperEnabled) {
        if (afterRegisterLogin) {
            htcmdService.registerNative({ userId, username: userName });
        } else {
            htcmdService.login({ userId, username: userName });
        }

        // do not reject here and continue regular login
    }
};
